import React, {Component} from "react";
import { ResponsivePie } from '@nivo/pie'
import './TimeChart.scss'
import {minutesToFormatted} from "../reports/dynamic-form/TimeTrackingField";
import classNames from 'classnames'

class TimeChart extends Component {

    get time() {
        let phase = this.props.phase
        let currentHours = Math.floor((this.props.hours/60) * 100) / 100

        return {
            currentHours,
            phaseHours: parseInt(phase.hours)
        }
    }
    get data() {
        let phase = this.props.phase
        let currentHours = Math.floor((this.props.hours/60) * 100) / 100

        if(currentHours <= 0) {
            return [
                {
                    color: 'rgb(255,191,191)',
                    value: parseInt(phase.hours),
                    id: 'remaining_time',
                    label: 'Remaining time'
                }
            ]
        }
        let remainingTime = parseFloat((parseInt(phase.hours) - currentHours).toFixed(2));
        if(remainingTime <= 0) {
          return [{
            color: 'rgb(98,176,109)',
            value: currentHours,
            id: 'training_time',
            label: 'Training time'
          }]
        }

        return [{
            color: 'rgb(252,229,63)',
            value: currentHours,
            id: 'training_time',
            label: 'Training time'
        }, {
            color: 'rgb(255,191,191)',
            value: remainingTime,
            id: 'remaining_time',
            label: 'Remaining time'
        }]
    }
    formatValue(hours) {
        let min = hours % 1;
        if(Math.round(min * 60) > 0) {
            return `${Math.floor(hours)}h ${Math.round(min * 60)}m`
        }

        return `${hours}h`
    }
    render() {
        return (
            <div className={classNames("time-chart", {compact: this.props.compact})} >
              {!this.props.hidePhase && <div className="phase-name">{this.props.phase.header} <small style={{
                color: "rgba(3,19,63,0.62)",
                fontSize: '1em'
              }}>({minutesToFormatted(this.time.phaseHours * 60)})</small></div>}
                <ResponsivePie
                    animate
                    data={this.data}
                    enableArcLinkLabels={false}
                    margin={this.props.compact?{top: 10, right: 20, bottom: 30, left: 20 }:{ top: 20, right: 50, bottom: 50, left: 50 }}
                    colors={this.data.map(d => d.color)}
                    valueFormat={(val) => this.formatValue(val)}
                    legends={[
                        {
                            anchor: 'bottom',
                            direction: 'row',
                            justify: false,
                            translateX: 0,
                            translateY: 30,
                            itemsSpacing: 0,
                            itemWidth: 100,
                            itemHeight: 18,
                            itemTextColor: '#999',
                            itemDirection: 'left-to-right',
                            itemOpacity: 1,
                            symbolSize: 14,
                            symbolShape: 'circle',
                            effects: [
                                {
                                    on: 'hover',
                                    style: {
                                        itemTextColor: '#000'
                                    }
                                }
                            ]
                        }
                    ]}
                />
            </div>
        )
    }
}

export default TimeChart
